import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
// import { renderRoutes } from 'react-router-config';
import "./style.css";
import Admin from "./pages/admin/Admin";
// import Cookies from 'js-cookie'
import PrintLetter from "./pages/admin/requstedLetters/PrintLetter";
import Student from "./pages/student/Student";
import Print from "pages/admin/report/Print";
import Error404 from "pages/error/404";
import Error403 from "pages/error/403";
import Error500 from "pages/error/500";

class App extends React.Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/admin" component={Admin} />
          <Route path="/surat/cetak" component={PrintLetter} exact={true} />
          <Route path="/laporan/cetak" component={Print} exact={true} />
          <Route path="/404" component={Error404} exact={true} />
          <Route path="/403" component={Error403} exact={true} />
          <Route path="/500" component={Error500} exact={true} />
          <Route path="/" name="Student" component={Student} exact={false} />
          <Redirect from="*" to="/404" />
        </Switch>
      </Router>
    );
  }
}

export default App;
